import { client } from '@platform/http/api-client';

// In-app notifications — the caller's own inbox. The account is taken
// from the JWT server-side; nothing identifying is sent from here.
const notificationsApi = {
  async getNotifications({ limit = 50, unreadOnly = false } = {}) {
    const response = await client.get('/api/notifications', { params: { limit, unread: unreadOnly ? 1 : 0 } });
    return response.data || { items: [], unread: 0 };
  },
  async markNotificationsRead(ids) {
    const response = await client.post('/api/notifications/read', { ids });
    return response.data;
  },
  async markAllNotificationsRead() {
    const response = await client.post('/api/notifications/read', { all: true });
    return response.data;
  },
};

export default notificationsApi;
